// pieces and components
const initLoadingBar = (stage) => {
	const loadingBar = document.querySelector('.global-loading-bar');
	const action =
		loadingBar.style.opacity == 1 && stage != 'done' ? 'move' : stage;

	switch (action) {
		case 'start':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				(window.innerWidth * (Math.floor(Math.random() * 6) + 1)) / 10 + 'px';
			break;

		case 'move':
			loadingBar.style.opacity = 1;
			loadingBar.style.width =
				loadingBar.getBoundingClientRect().width * 1.15 + 'px';
			break;

		case 'done':
			loadingBar.style.width = window.innerWidth + 'px';

			setTimeout(function () {
				loadingBar.style.opacity = 0;
			}, 400);

			setTimeout(function () {
				loadingBar.style.width = 0;
			}, 800);
			break;
	}
};

const initMarquee = () => {
	const marquees = document.querySelectorAll('.marquee');

	marquees.forEach((marquee) => {
		setTimeout(() => {
			// block content must be greater the window's innerWidth
			const marqueeContent = marquee.querySelectorAll('.marquee-content');
			const maruqeeBlockWidth = marqueeContent[0].clientWidth;
			const factor = Math.ceil(innerWidth / maruqeeBlockWidth);
			const marqueeHtml = marqueeContent[0].innerHTML;
			const pixelPerSecond = 150;
			const speed =
				((maruqeeBlockWidth * factor) / pixelPerSecond) *
				(marquee.dataset.speed || 1);

			marqueeContent.forEach((block) => {
				// override default speed if specified?
				block.style.animationDuration = `${parseInt(speed)}s`;

				// should we replicate content to fill the window's innerWidth?
				if (isFinite(factor)) {
					for (i = 0; i < factor; i++) {
						// if so, repeat block content
						block.insertAdjacentHTML('beforeend', marqueeHtml);
					}
				}
			});
		}, 1);
	});
};

const initAccordions = () => {
	const toggleAccordion = (accordion, closeSiblings) => {
		const accordionContent = accordion.querySelector('.accordion-content');

		if (closeSiblings) {
			getSiblings(accordion).forEach((item) => {
				if (item.classList.contains('is-expanded')) {
					toggleAccordion(item, false);
				}
			});
		}

		accordion.classList.toggle('is-expanded');

		if (accordion.classList.contains('is-expanded')) {
			accordion.setAttribute('aria-expanded', true);
			accordionContent.setAttribute('aria-hidden', false);
			accordionContent.style.height = `${
				accordionContent.querySelector('.content-interior').clientHeight
			}px`;

			if (accordionContent.querySelector('input[type="text"]')) {
				let inputField = accordionContent.querySelector('input[type="text"]');
				const end = inputField.value.length;
				inputField.setSelectionRange(end, end);
				inputField.focus();
			}
		} else {
			accordion.setAttribute('aria-expanded', false);
			accordionContent.setAttribute('aria-hidden', true);
			accordionContent.style.height = '0px';
		}
	};

	on('button', 'click', '.js-toggle-accordion', (e) => {
		let accordion = e.target.closest('.comp-accordion');
		toggleAccordion(
			accordion,
			accordion.classList.contains('is-close-siblings')
		);
	});
};

const initEmailCapture = () => {
	on('body', 'submit', '.comp-email-capture', (e) => {
		e.preventDefault();
		const form = e.target;
		const submitEmail = (listID, email, phone) => {
			let phoneNum = phone;

			const options = {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: `Basic ${getAuthToken()}`,
				},
				body: JSON.stringify({
					serviceTarget: 'edie-parker',
					listID: listID,
					email: email,
					phoneNumber: `${phoneNum ? '+1' + phoneNum : ''}`,
				}),
			};
			let isPhoneValid = true;

			if (phoneNum) {
				phoneNum = '+1' + phoneNum;

				if (!validatePhone(phoneNum)) {
					form.classList.add('is-error-phone');

					isPhoneValid = false;
				} else {
					isPhoneValid = true;
				}
			}

			if (!validateEmail(email)) {
				form.classList.add('is-error-email');
			}

			if (validateEmail(email) && isPhoneValid) {
				fetch('https://vs-service.vercel.app/api/klaviyo/subscribe', options)
					.then((response) => response.json())
					.then((response) => {
						form.classList.add('is-success');
					})
					.catch((err) => console.error(err));
			}
		};

		submitEmail(
			form.querySelector('input[name="g"]').value,
			form.querySelector('input[type="email"]').value,
			form.querySelector('input[type="tel"]')
				? form.querySelector('input[type="tel"]').value
				: ''
		);
	});

	on('body', 'keydown', '.comp-email-capture input[type="email"]', (e) => {
		e.target.closest('.comp-email-capture').classList.remove('is-error-email');
	});

	on('body', 'focus', '.comp-email-capture input[type="email"]', (e) => {
		e.target.closest('.comp-email-capture').classList.remove('is-error-email');
	});

	on('body', 'keydown', '.comp-email-capture input[type="tel"]', (e) => {
		e.target.closest('.comp-email-capture').classList.remove('is-error-phone');
	});

	on('body', 'focus', '.comp-email-capture input[type="tel"]', (e) => {
		e.target.closest('.comp-email-capture').classList.remove('is-error-phone');
	});
};

const initItemQuantity = () => {
	on('body', 'click', '[data-quantity-trigger]', (e) => {
		let target = e.target.dataset.quantityTrigger
			? e.target
			: e.target.closest('[data-quantity-trigger]');
		let itemQuantity = target.closest('.item-quantity');
		let quantityInput = itemQuantity.querySelector('input[name="quantity"]');
		let inputDecrease = itemQuantity.querySelector(
			'[data-quantity-trigger="decrease"]'
		);
		let inputIncrease = itemQuantity.querySelector(
			'[data-quantity-trigger="increase"]'
		);
		let updatedValue =
			parseInt(quantityInput.value) +
			(target.dataset.quantityTrigger == 'increase'
				? parseInt(quantityInput.value) + 1 <= parseInt(quantityInput.max)
					? 1
					: 0
				: parseInt(quantityInput.value) - 1 >= parseInt(quantityInput.min)
				? -1
				: 0);

		updatedValue <= quantityInput.min
			? inputDecrease.classList.add('is-inactive')
			: inputDecrease.classList.remove('is-inactive');

		updatedValue >= quantityInput.max
			? inputIncrease.classList.add('is-inactive')
			: inputIncrease.classList.remove('is-inactive');

		quantityInput.value = target.classList.contains('has-leading-zero')
			? formatLeadingZero(updatedValue)
			: updatedValue;


	});
};

const initFields = () => {
	const fields = document.querySelectorAll('.field');

	fields.forEach((item) => {
		let input = item.querySelector(`input[type="text"],
			input[type="email"],
			input[type="tel"],
			input[type="url"],
			input[type="password"],
			input[type="file"],
			textarea`);
		let determineHasValue = () => {
			input.value
				? item.classList.add('has-value')
				: item.classList.remove('has-value');
		};

		if (input) {
			determineHasValue();
			input.addEventListener('change', determineHasValue);
			input.addEventListener('blur', determineHasValue);
		}
	});
};

// global elements and pages
// Product Page Gallery
const initPDPGallery = () => {
	var sync1 = $('#product-large');
	var sync2 = $('#product-thumb');
	var slidesPerPage = 1; //globaly define number of elements per page
	var syncedSecondary = true;

	sync1
		.owlCarousel({
			items: 1,
			nav: true,
			autoplay: false,
			dots: false,
			loop: true,
			responsiveRefreshRate: 200,
			smartSpeed: 800,
			navText: [
				'<svg class="svg-arrow-left" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1 1 9l8 8M1 9h19" stroke="currentColor"></path></svg>',
				'<svg class="svg-arrow-right" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11 17 8-8-8-8M19 9H0" stroke="currentColor"></path></svg>',
			],
		})
		.on('changed.owl.carousel', syncPosition);

	sync2
		.on('initialized.owl.carousel', function () {
			sync2.find('.owl-item').eq(0).addClass('current');
		})
		.owlCarousel({
			items: slidesPerPage,
			dots: false,
			nav: false,
			touchDrag: false,
			slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
			smartSpeed: 800,
			responsiveRefreshRate: 100,
		})
		.on('changed.owl.carousel', syncPosition2);

	function syncPosition(el) {
		//if you set loop to false, you have to restore this next line
		//var current = el.item.index;

		//if you disable loop you have to comment this block
		var count = el.item.count - 1;
		var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

		if (current < 0) {
			current = count;
		}
		if (current > count) {
			current = 0;
		}

		//end block

		sync2
			.find('.owl-item')
			.removeClass('current')
			.eq(current)
			.addClass('current');
		var onscreen = sync2.find('.owl-item.active').length - 1;
		var start = sync2.find('.owl-item.active').first().index();
		var end = sync2.find('.owl-item.active').last().index();

		if (current > end) {
			sync2.data('owl.carousel').to(current, 100, true);
		}
		if (current < start) {
			sync2.data('owl.carousel').to(current - onscreen, 100, true);
		}
	}

	function syncPosition2(el) {
		if (syncedSecondary) {
			var number = el.item.index;
			sync1.data('owl.carousel').to(number, 100, true);
		}
	}

	sync2.on('click', '.owl-item', function (e) {
		e.preventDefault();
		var number = $(this).index();
		sync1.data('owl.carousel').to(number, 300, true);
	});
};
// END Product Page Gallery

const initEmblaSlider = () => {
	document.querySelectorAll('[data-embla-slider]').forEach((el) => {
		const viewportNode = el.querySelector('.embla-viewport');
		const dots = el.querySelector('.embla-dots');
		const autoDefault = el.dataset.auto == 'true' ? true : false;
		const autoInterval = el.dataset.autoInterval;
		//need to condition whether auto is included

		const autoplay = EmblaCarouselAutoplay(
			{
				delay: autoInterval ? autoInterval : 6000,
				stopOnInteraction: true,
				playOnInit: autoDefault,
				speed: 5,
			},
			(emblaRoot) => emblaRoot.parentElement
		);
		const className = EmblaCarouselClassNames(
			{ selected: 'is-selected' },
			(emblaRoot) => emblaRoot.parentElement
		);

		let options = JSON.parse(el.dataset.emblaSlider.replace(/'/g, '"').trim());

		let embla = EmblaCarousel(viewportNode, options, [autoplay, className]);

		embla.slideNodes().length == 1 ? embla.destroy() : '';

		const toggleEmblaReady = (event) => {
			const isResizeEvent = event === 'resize';
			const toggleClass = isResizeEvent ? 'remove' : 'add';
			viewportNode.classList[toggleClass]('embla--is-ready');
			if (isResizeEvent) embla.reInit();
		};

		embla
			.on('init', toggleEmblaReady)
			.on('resize', toggleEmblaReady)
			.on('reInit', toggleEmblaReady);

		// Grab button nodes
		let prevButtonNode = el.querySelector('.embla-prev');
		let nextButtonNode = el.querySelector('.embla-next');

		if (prevButtonNode || nextButtonNode) {
			prevButtonNode.addEventListener('click', embla.scrollPrev, false);
			nextButtonNode.addEventListener('click', embla.scrollNext, false);
		}

		//dots setup

		if (dots && embla.slideNodes().length > 1) {
			const setupDotBtns = (dotsArray, embla) => {
				dotsArray.forEach((dotNode, i) => {
					dotNode.classList.add('embla-dot', 'expand-clickable-area');
					dotNode.addEventListener('click', () => embla.scrollTo(i), false);
				});
			};

			const generateDotBtns = (dots, embla) => {
				const scrollSnaps = embla.scrollSnapList();
				const dotsFrag = document.createDocumentFragment();
				const dotsArray = scrollSnaps.map(() =>
					document.createElement('button')
				);
				dotsArray.forEach((dotNode) => {
					dotsFrag.appendChild(dotNode);
				});
				dots.appendChild(dotsFrag);
				return dotsArray;
			};

			const selectDotBtn = (dotsArray, embla) => () => {
				const previous = embla.previousScrollSnap();
				const selected = embla.selectedScrollSnap();
				dotsArray[previous].classList.remove('is-selected');
				dotsArray[selected].classList.add('is-selected');
			};

			const dotsArray = generateDotBtns(dots, embla);
			const setSelectedDotBtn = selectDotBtn(dotsArray, embla);
			setupDotBtns(dotsArray, embla);

			embla.on('init', setSelectedDotBtn).on('select', setSelectedDotBtn);
		}

		//prevent drag click
		const onSlideClick = (slideNode, index) => {
			slideNode.addEventListener('click', (e) => {
				if (embla.clickAllowed()) return;

				e.preventDefault();
				e.stopImmediatePropagation();
			});
		};

		embla.slideNodes().forEach(onSlideClick);
	});
};

const initVimeoPlayer = () => {
	const videoIframes = document.querySelectorAll('.js-vimeo-video-defer');

	const options = {
		loop: true,
		muted: true,
		background: true,
		responsive: true,
	};

	videoIframes.forEach((iframe) => {
		let observer = new IntersectionObserver(
			(el) => {
				if (el[0].isIntersecting === true) {
					let player = new Vimeo.Player(el[0].target, options);
					player.on('loaded', () => {
						player.play();
					});

					player.on('play', function () {
						//fade out thumbnail
						el[0].target.nextElementSibling.classList.add('css_fade_out');
					});
				}
			},
			{
				root: null,
				threshold: [0], // 0 = page start; 1 = page bottom, items only revealed when in full view
			}
		);

		observer.observe(iframe);
	});
};

const initMatch = () => {
	function matchTrigger(trigger, triggerAttr, targetAttr, isHover = false) {
		//trigger active state
		if (!isHover) {
			getSiblings(trigger).forEach((item) => {
				item.classList.remove('is-active');
			});
			trigger.classList.add('is-active');
		}
		//find target under parent js-match
		trigger
			.closest('.js-match')
			.querySelectorAll(`[${targetAttr}]`)
			.forEach((target) => {
				target.classList.remove('is-active');
				let activeTarget = trigger
					.closest('.js-match')
					.querySelector(
						`[${targetAttr}="${trigger.getAttribute(triggerAttr)}"]`
					);
				activeTarget.classList.add('is-active');
			});
	}

	function matchLeave(trigger, targetAttr) {
		if (!isHover) {
			getSiblings(trigger).forEach((item) => {
				item.classList.remove('is-active');
			});
		}
		// trigger.classList.remove('is-active');

		//find target under parent js-match
		trigger
			.closest('.js-match')
			.querySelectorAll(`[${targetAttr}]`)
			.forEach((target, index) => {
				index == 0
					? target.classList.add('is-active')
					: target.classList.remove('is-active');
			});
	}
	//hover match
	on('body', 'mouseover', '[data-match-hover-trigger]', (e) => {
		let trigger = e.target.closest('[data-match-hover-trigger]');
		matchTrigger(
			trigger,
			'data-match-hover-trigger',
			'data-match-hover-target',
			true
		);
	});

	on('body', 'touchend', '[data-match-hover-trigger]', (e) => {
		let trigger = e.target.closest('[data-match-hover-trigger]');
		window.location.href = trigger.getAttribute('href');
	});

	on('body', 'mouseout', '[data-match-hover-trigger]', (e) => {
		let trigger = e.target.closest('[data-match-hover-trigger]');
		matchLeave(trigger, 'data-match-hover-target', '', true);
	});

	//match navigation with content
	on('body', 'click', '[data-match-trigger]', (e) => {
		let trigger = e.target.closest('[data-match-trigger]');
		matchTrigger(trigger, 'data-match-trigger', 'data-match-target');
		//find secondary target under parent js-match
		matchTrigger(
			trigger,
			'data-match-trigger',
			'data-match-target-secondary',
			false
		);
	});
};
const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach((item) => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == window.location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
			item.target = item.target || '_blank';
		}
	});

	on('body', 'click', '[data-page-transition]', (e) => {
		let target = e.target.hasAttribute('data-page-transition')
			? e.target
			: e.target.closest('[data-page-transition]');

		target.blur();

		if (
			target.dataset.pageTransition == 'internal' &&
			!root.classList.contains('key-is-down')
		) {
			e.preventDefault();
			root.classList.remove(
				'header-is-sticky',
				'menu-is-active',
				'mobile-menu-is-active',
				'minicart-is-active',
				'header-menu-active',
				'overlay-is-active'
			);

			root.classList.add('is_leaving');

			setTimeout(() => {
				location.href = target.href;
			}, 400);
		} else if (target.dataset.pageTransition == 'scroll') {
			e.preventDefault();
			seamless.elementScrollIntoView(
				document.querySelector(`#${target.href.split('#')[1]}`),
				{
					behavior: 'smooth',
				}
			);
		}
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('[data-animate]').forEach((item) => {
		let observer = new IntersectionObserver(
			(el) => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{
				root: null,
				threshold: [0.4], // 0 = page start; 1 = page bottom, items only revealed when in full view
			}
		);

		observer.observe(item);
	});
};

const initComboBox = () => {
	'use strict';

	// Save a list of named combobox actions, for future readability
	const SelectActions = {
		Close: 0,
		CloseSelect: 1,
		First: 2,
		Last: 3,
		Next: 4,
		Open: 5,
		PageDown: 6,
		PageUp: 7,
		Previous: 8,
		Select: 9,
		Type: 10,
	};

	/*
	 * Helper functions
	 */

	// filter an array of options against an input string
	// returns an array of options that begin with the filter string, case-independent
	function filterOptions(options = [], filter, exclude = []) {
		return options.filter((option) => {
			const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
			return matches && exclude.indexOf(option) < 0;
		});
	}

	// map a key press to an action
	function getActionFromKey(event, menuOpen) {
		const { key, altKey, ctrlKey, metaKey } = event;
		const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action
		// handle opening when closed
		if (!menuOpen && openKeys.includes(key)) {
			return SelectActions.Open;
		}

		// home and end move the selected option when open or closed
		if (key === 'Home') {
			return SelectActions.First;
		}
		if (key === 'End') {
			return SelectActions.Last;
		}

		// handle typing characters when open or closed
		if (
			key === 'Backspace' ||
			key === 'Clear' ||
			(key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)
		) {
			return SelectActions.Type;
		}

		// handle keys when open
		if (menuOpen) {
			if (key === 'ArrowUp' && altKey) {
				return SelectActions.CloseSelect;
			} else if (key === 'ArrowDown' && !altKey) {
				return SelectActions.Next;
			} else if (key === 'ArrowUp') {
				return SelectActions.Previous;
			} else if (key === 'PageUp') {
				return SelectActions.PageUp;
			} else if (key === 'PageDown') {
				return SelectActions.PageDown;
			} else if (key === 'Escape') {
				return SelectActions.Close;
			} else if (key === 'Enter' || key === ' ') {
				return SelectActions.CloseSelect;
			}
		}
	}

	// return the index of an option from an array of options, based on a search string
	// if the filter is multiple iterations of the same letter (e.g "aaa"), then cycle through first-letter matches
	function getIndexByLetter(options, filter, startIndex = 0) {
		const orderedOptions = [
			...options.slice(startIndex),
			...options.slice(0, startIndex),
		];
		const firstMatch = filterOptions(orderedOptions, filter)[0];
		const allSameLetter = (array) =>
			array.every((letter) => letter === array[0]);

		// first check if there is an exact match for the typed string
		if (firstMatch) {
			return options.indexOf(firstMatch);
		}

		// if the same letter is being repeated, cycle through first-letter matches
		else if (allSameLetter(filter.split(''))) {
			const matches = filterOptions(orderedOptions, filter[0]);
			return options.indexOf(matches[0]);
		}

		// if no matches, return -1
		else {
			return -1;
		}
	}

	// get an updated option index after performing an action
	function getUpdatedIndex(currentIndex, maxIndex, action) {
		const pageSize = 10; // used for pageup/pagedown

		switch (action) {
			case SelectActions.First:
				return 0;
			case SelectActions.Last:
				return maxIndex;
			case SelectActions.Previous:
				return Math.max(0, currentIndex - 1);
			case SelectActions.Next:
				return Math.min(maxIndex, currentIndex + 1);
			case SelectActions.PageUp:
				return Math.max(0, currentIndex - pageSize);
			case SelectActions.PageDown:
				return Math.min(maxIndex, currentIndex + pageSize);
			default:
				return currentIndex;
		}
	}

	// check if element is visible in browser view port
	function isElementInView(element) {
		var bounding = element.getBoundingClientRect();

		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	// check if an element is currently scrollable
	function isScrollable(element) {
		return element && element.clientHeight < element.scrollHeight;
	}

	// check if on mobile or tablet device
	function isMobileOrTablet() {
		const userAgent = navigator.userAgent.toLowerCase();

		return (
			/iPhone|Android/i.test(navigator.userAgent) ||
			/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
				userAgent
			)
		);
	}

	// ensure a given child element is within the parent's visible scroll area
	// if the child is not visible, scroll the parent
	function maintainScrollVisibility(activeElement, scrollParent) {
		const { offsetHeight, offsetTop } = activeElement;
		const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;

		const isAbove = offsetTop < scrollTop;
		const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

		if (isAbove) {
			scrollParent.scrollTo(0, offsetTop);
		} else if (isBelow) {
			scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
		}
	}

	/*
	 * Select Component
	 * Accepts a combobox element and an array of string options
	 */
	const Select = function (el, options = []) {
		// element refs
		this.el = el;
		this.selector = this.el.querySelector('select');
		this.comboBox = el.querySelector('.combobox');
		this.comboEl = document.createElement('div');
		this.listboxEl = document.createElement('div');

		this.comboEl.setAttribute('aria-controls', `${this.el.id}-listbox`);
		this.comboEl.setAttribute('aria-expanded', false);
		this.comboEl.setAttribute('aria-haspopup', 'listbox');
		this.comboEl.setAttribute('aria-labelledby', `${this.el.id}-label`);
		this.comboEl.setAttribute('role', 'combobox');
		this.comboEl.setAttribute('tabindex', 0);
		this.comboEl.id = `${this.el.id}-input`;
		this.comboEl.classList.add('combobox-input');
		this.comboBox.prepend(this.comboEl);
		this.comboEl.innerHTML = `<span class=combobox-input-value></span>`;
		this.listboxEl.setAttribute('aria-labelledby', `${this.el.id}-label`);
		this.listboxEl.setAttribute('role', 'listbox');
		this.listboxEl.setAttribute('tabindex', '-1');
		this.listboxEl.id = `${this.el.id}-listbox`;
		this.listboxEl.classList.add('combobox-menu');
		this.listboxEl.setAttribute('data-dropdown-selector', '');
		this.comboBox.prepend(this.listboxEl);

		// data
		this.idBase = this.comboEl.id || 'combo';
		this.options = options;

		// state
		this.activeIndex = 0;
		this.open = false;
		this.searchString = '';
		this.searchTimeout = null;

		// init
		if (el && this.comboEl && this.listboxEl) {
			this.init();

			// assign ID to <label> and <select>
			this.el
				.querySelector('label')
				.setAttribute('for', `${this.el.id}-select`);
			this.selector.id = `${this.el.id}-select`;

			// match <select> actions to combobox
			this.selector.addEventListener('change', (event) => {
				event.stopPropagation();
				this.onOptionClick(this.selector.selectedIndex);
			});

			if (isMobileOrTablet()) {
				this.listboxEl.setAttribute('aria-hidden', true);
			} else {
				// this.el.classList.add('is-select-hidden');
			}
		}
	};

	Select.prototype.init = function () {
		// select first option by default
		this.comboEl.querySelector('span').innerText = this.options[0].text;

		// add event listeners
		this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
		this.comboEl.addEventListener('click', this.onComboClick.bind(this));
		this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));

		// create options
		this.options.map((option, index) => {
			const optionEl = this.createOption(option, index);
			this.listboxEl.appendChild(optionEl);
		});
	};

	Select.prototype.createOption = function (option, index) {
		const optionEl = document.createElement('div');
		optionEl.setAttribute('role', 'option');
		optionEl.id = `${this.idBase}-${index}`;
		optionEl.className =
			'combobox-option cursor-hover btn-dot is-small is-blue';
		optionEl.setAttribute('aria-selected', `${index === 0}`);
		optionEl.innerHTML = `<span>${option.text}</span>`;
		option.attr != 'undefined'
			? optionEl.setAttribute('data-sort-trigger', `${option.attr}`)
			: '';

		optionEl.addEventListener('click', (event) => {
			this.onOptionClick(index);
		});
		optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));

		return optionEl;
	};

	Select.prototype.getSearchString = function (char) {
		// reset typing timeout and start new timeout
		// this allows us to make multiple-letter matches, like a native select
		if (typeof this.searchTimeout === 'number') {
			window.clearTimeout(this.searchTimeout);
		}

		this.searchTimeout = window.setTimeout(() => {
			this.searchString = '';
		}, 500);

		// add most recent letter to saved search string
		this.searchString += char;
		return this.searchString;
	};

	Select.prototype.onComboBlur = function () {
		// do not do blur action if ignoreBlur flag has been set
		if (this.ignoreBlur) {
			this.ignoreBlur = false;
			return;
		}

		// select current option and close
		if (this.open) {
			this.selectOption(this.activeIndex);
			this.updateMenuState(false, false);
		}
	};

	Select.prototype.onComboClick = function () {
		this.updateMenuState(!this.open, false);
	};

	Select.prototype.onComboKeyDown = function (event) {
		const { key } = event;
		const max = this.options.length - 1;

		const action = getActionFromKey(event, this.open);

		switch (action) {
			case SelectActions.Last:
			case SelectActions.First:
				this.updateMenuState(true);
			// intentional fallthrough

			case SelectActions.Next:
			case SelectActions.Previous:
			case SelectActions.PageUp:
			case SelectActions.PageDown:
				event.preventDefault();
				return this.onOptionChange(
					getUpdatedIndex(this.activeIndex, max, action)
				);
			case SelectActions.CloseSelect:
				event.preventDefault();
				this.selectOption(this.activeIndex);
			// intentional fallthrough

			case SelectActions.Close:
				event.preventDefault();
				return this.updateMenuState(false);
			case SelectActions.Type:
				return this.onComboType(key);
			case SelectActions.Open:
				event.preventDefault();
				return this.updateMenuState(true);
		}
	};

	Select.prototype.onComboType = function (letter) {
		// open the listbox if it is closed
		this.updateMenuState(true);

		// find the index of the first matching option
		const searchString = this.getSearchString(letter);
		const searchIndex = getIndexByLetter(
			this.options,
			searchString,
			this.activeIndex + 1
		);

		// if a match was found, go to it
		if (searchIndex >= 0) {
			this.onOptionChange(searchIndex);
		}
		// if no matches, clear the timeout and search string
		else {
			window.clearTimeout(this.searchTimeout);
			this.searchString = '';
		}
	};

	Select.prototype.onOptionChange = function (index) {
		// update state
		this.activeIndex = index;

		// update aria-activedescendant
		this.comboEl.setAttribute(
			'aria-activedescendant',
			`${this.idBase}-${index}`
		);

		// update active option styles
		const options = this.el.querySelectorAll('[role=option]');
		[...options].forEach((optionEl) => {
			optionEl.classList.remove('is-active');
		});
		options[index].classList.add('is-active');

		// ensure the new option is in view
		if (isScrollable(this.listboxEl)) {
			maintainScrollVisibility(options[index], this.listboxEl);
		}

		// ensure the new option is visible on screen
		// ensure the new option is in view
		if (!isElementInView(options[index])) {
			options[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	};

	Select.prototype.onOptionClick = function (index) {
		this.onOptionChange(index);
		this.selectOption(index);
		this.updateMenuState(false);
	};

	Select.prototype.onOptionMouseDown = function () {
		// Clicking an option will cause a blur event,
		// but we don't want to perform the default keyboard blur action
		this.ignoreBlur = true;
	};

	Select.prototype.selectOption = function (index) {
		// update state
		this.activeIndex = index;

		// update displayed value
		const selected = this.options[index].text;

		//insert into span inside of combo-input
		this.comboEl.querySelector('span').innerText = selected;

		// update aria-selected
		const options = this.el.querySelectorAll('[role=option]');
		[...options].forEach((optionEl) => {
			optionEl.setAttribute('aria-selected', 'false');
		});
		options[index].setAttribute('aria-selected', 'true');

		// update <select>
		this.selector.value = this.selector.querySelectorAll('option')[index].value;
	};

	Select.prototype.updateMenuState = function (open, callFocus = true) {
		if (this.open === open) {
			return;
		}

		// update state
		this.open = open;

		// update aria-expanded and styles
		this.comboEl.setAttribute('aria-expanded', `${open}`);
		open
			? this.el.classList.add('is-active')
			: this.el.classList.remove('is-active');

		// update activedescendant
		const activeID = open ? `${this.idBase}-${this.activeIndex}` : '';
		this.comboEl.setAttribute('aria-activedescendant', activeID);

		if (activeID === '' && !isElementInView(this.comboEl)) {
			this.comboEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}

		// move focus back to the selector, if needed
		callFocus && this.comboEl.focus();
	};

	// init select
	document.querySelectorAll('.combobox-selector').forEach((el) => {
		let options = [];

		el.querySelectorAll('option').forEach((option) => {
			option.hasAttribute('data-sort-trigger')
				? options.push({
						text: option.innerText,
						attr: option.dataset.sortTrigger,
				  })
				: options.push({
						text: option.innerText,
				  });
		});

		new Select(el, options);
	});
};

const initContentLayout = () => {
	// iframe fit vids
	reframe(
		'.content-layout iframe[src*="vimeo.com"], .content-layout iframe[src*="youtube.com"]',
		'video-reframe'
	);

	// unwrap image from paragraph tag
	let contentLayout = document.querySelector('.content-layout');
	if (contentLayout) {
		[].forEach.call(contentLayout.getElementsByTagName('img'), function (img) {
			let p = img.closest('p');

			if (p && p.parentElement) {
				p.parentElement.insertBefore(img, p);
				p.parentElement.removeChild(p);
			}
		});
	}

	// instagram aspect ratio
	let instagramEmbed = document.querySelectorAll('iframe.instagram-media');
	instagramEmbed.forEach((el) => {
		el.addEventListener('load', () => {
			setTimeout(() => {
				el.style.height = `${el.getAttribute('height')}px`;
			}, 1500);
		});
	});
};

const initCart = () => {
	// cart visibility

	isOverflown(document.querySelector('.minicart-content'))
		? document.querySelector('.mini-cart-promos').classList.add('has-shadow')
		: document
				.querySelector('.mini-cart-promos')
				.classList.remove('has-shadow');
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		history.pushState(null, null, ' ');
		scrollEnable();
	};

	const minicartOpen = () => {
		root.classList.add('minicart-is-active');
		history.pushState(null, null, '#cart');
		scrollDisable();
	};

	on('body', 'click', '.minicart-open', (e) => {
		root.classList.contains('minicart-is-active')
			? minicartClose()
			: minicartOpen();
	});

	on('body', 'click', '.minicart-close', (e) => {
		minicartClose();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key == 'Escape') {
			minicartClose();
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	// updates both cart price and item count
	this.reloadCartData = () => {
		fetch('/cart.js')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				document.querySelectorAll('.cart-total-price').forEach((item) => {
					item.innerText = `$${parseFloat(data.total_price / 100).toFixed(2)}`;
				});
				// Sean Add - Mini Cart Coupon Update
				document.querySelectorAll('.cart-total-coupon-discount').forEach((item) => {
					item.innerText = `$${parseFloat(data.total_discount / 100).toFixed(2)}`;
				});
				document.querySelectorAll('.cart-original-total').forEach((item) => {
					item.innerText = `$${parseFloat(data.original_total_price / 100).toFixed(2)}`;
				});
				document.querySelectorAll('.coupon-savings-tally').forEach((item) => {
					item.innerText = `$${parseFloat(data.total_discount / 100).toFixed(2)}`;
				});
				// End Sean Add
				document.querySelectorAll('.cart-total-items').forEach((item) => {
					item.innerText = data.item_count;
				});

				data.item_count > 0
					? root.classList.add('cart-has-items')
					: root.classList.remove('cart-has-items');
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// updates .cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				initLoadingBar('done');

				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');
				// insert the new cart items
				document.querySelectorAll('.cart-items-wrapper').forEach((item) => {
					item.innerHTML = dataHtml.querySelector(
						'.cart-items-wrapper'
					).innerHTML;
				});

				isOverflown(document.querySelector('.minicart-content'))
					? document
							.querySelector('.mini-cart-promos')
							.classList.add('has-shadow')
					: document
							.querySelector('.mini-cart-promos')
							.classList.remove('has-shadow');
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		items,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400
	) => {
		initLoadingBar('start');

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				items: items,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then((response) => {
				response.json();
			})
			.then((data) => {
				initLoadingBar('move');

				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		line,
		quantity,
		updateCartTotal = true,
		updateCartItems = false,
		minicartOpenDelay = 400
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				line: line,
				quantity: quantity,
			}),
		})
			.then((response) => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
			})

			.catch((error) => {
				console.error('Error:', error);
			});

	};

	on('body', 'click', '[data-quantity-trigger]', (e) => {
		let target = e.target.closest('[data-quantity-trigger]');
		let item = e.target.closest('.cart-item');

		if (item) {
			item.querySelectorAll('[name="quantity"]').forEach((item) => {
				item.value = target
					.closest('.item-quantity')
					.querySelector('[name="quantity"]').value;
			});

			changeItemQuantity(
				item.dataset.itemLine,
				item.querySelector('[name="quantity"]').value || 1,
				true,
				false,
				false
			);


		}

	});

	on('body', 'click', '.item-remove-trigger', (e) => {

		let item = e.target.closest('.cart-item');

		// if (document.querySelectorAll('[data-item-customize]').length > 1) {
		if (item.hasAttribute('data-item-customize')) {
			console.log("Custom Item Removed");
			let removeVariantId = [];
			const customizeItems = document.querySelectorAll('[data-item-customize]');

			const removeCustomizeItems = (removeVariantId) => {
				let formData = {
					updates: {},
				};

				let id;
				for (id in removeVariantId) {
					formData['updates'][parseInt(removeVariantId[id])] = 0;
				}

				fetch('/cart/update.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(formData),
				})
					.then((response) => response.json())
					.then((data) => {
						reloadCartData();
						reloadCartItems();
					})
					.catch((error) => {
						console.error('Error:', error);
					});
			};

			customizeItems.forEach((customizeItem) => {
				customizeItem.dataset.itemCustomize == item.dataset.itemId
					? removeVariantId.push(customizeItem.dataset.itemId)
					: '';
			});

			removeCustomizeItems(removeVariantId);

		} else if (item) {
			console.log("Regular Item Removed");
			item.remove();
			changeItemQuantity(item.dataset.itemLine, 0, true, true, false);

		}

		if (document.getElementById('template-cart')) {
			setTimeout(() => {
					location.reload();
			}, 500);
		}




	});


	on('body', 'click', '[data-cart-add-id]', (e) => {
		let target = e.target.closest('[data-cart-add-id]');

		addItem(target.dataset.cartAddId, target.dataset.cartAddQuantity || 1);
	});

	on('body', 'submit', 'form[action="/cart/add"]', (e) => {
		e.preventDefault();
		let form = e.target;
		const formSubmit = form.querySelector('[data-add-id]');
		const isDoubleSide = root.classList.contains('customizer-double-side');
		const hasGiftWrap = root.classList.contains('customizer-gift-wrap');
		const hasFrontShadow = root.classList.contains(
			'front-message-shadow-addon'
		);
		const hasBackShadow = root.classList.contains('back-message-shadow-addon');
		const hasBaseShadow = root.classList.contains('base-message-shadow-addon');

		const customizeProperties = form.classList.contains('is-customizable')
			? {
					properties: {
						'_Base Color': `${
							form.querySelector('[name="properties[Base Color]"]:checked')
								? form.querySelector('[name="properties[Base Color]"]:checked')
										.value
								: ''
						}`,
						'_Hardware Color': `${
							form.querySelector('[name="properties[Hardware Color]"]:checked')
								? form.querySelector(
										'[name="properties[Hardware Color]"]:checked'
								  ).value
								: ''
						}`,
						'_Border Color': `${
							form.querySelector('[name="properties[Border Color]"]:checked')
								? form.querySelector(
										'[name="properties[Border Color]"]:checked'
								  ).value
								: ''
						}`,
						'_Base Message': `${
							form.querySelector('[name="properties[Base Message]"]')
								? form.querySelector('[name="properties[Base Message]"]').value
								: ''
						}`,
						'_Message Color': `${
							form.querySelector('[name="properties[Message Color]"]:checked')
								? form.querySelector(
										'[name="properties[Message Color]"]:checked'
								  ).value
								: ''
						}`,
						'_Message Font': `${
							form.querySelector('[name="properties[Message Style]"]:checked')
								? form.querySelector(
										'[name="properties[Message Style]"]:checked'
								  ).value
								: ''
						}`,
						'_Base Message Shadow': `${
							hasBaseShadow &&
							form.querySelector(
								'[name="properties[Base Message Shadow]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Base Message Shadow]"]:checked'
								  ).value
								: ''
						}`,
						'_Front Message': `${
							form.querySelector('[name="properties[Front Message]"]')
								? form.querySelector('[name="properties[Front Message]"]').value
								: ''
						}`,
						'_Front Message Color': `${
							form.querySelector(
								'[name="properties[Front Message Color]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Front Message Color]"]:checked'
								  ).value
								: ''
						}`,
						'_Front Message Style': `${
							form.querySelector(
								'[name="properties[Front Message Style]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Front Message Style]"]:checked'
								  ).value
								: ''
						}`,
						'_Front Message Shadow': `${
							hasFrontShadow &&
							form.querySelector(
								'[name="properties[Front Message Shadow]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Front Message Shadow]"]:checked'
								  ).value
								: ''
						}`,
						'_Back Message': `${
							isDoubleSide &&
							form.querySelector('[name="properties[Back Message]"]')
								? form.querySelector('[name="properties[Back Message]"]').value
								: ''
						}`,
						'_Back Message Color': `${
							isDoubleSide &&
							form.querySelector(
								'[name="properties[Back Message Color]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Back Message Color]"]:checked'
								  ).value
								: ''
						}`,
						'_Back Message Style': `${
							isDoubleSide &&
							form.querySelector(
								'[name="properties[Back Message Style]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Back Message Style]"]:checked'
								  ).value
								: ''
						}`,
						'_Back Message Shadow': `${
							hasBackShadow &&
							form.querySelector(
								'[name="properties[Back Message Shadow]"]:checked'
							)
								? form.querySelector(
										'[name="properties[Back Message Shadow]"]:checked'
								  ).value
								: ''
						}`,
						'_Gift Wrap Message': `${
							hasGiftWrap ||
							form.querySelector('[name="properties[Gift Wrap Message]"]')
								? form.querySelector('[name="properties[Gift Wrap Message]"]')
										.value || 'No gift message'
								: ''
						}`,
						_Type: 'Customize',
						_Url: `${
							document.querySelector('.product-customizer-renderer').dataset
								.customizeSettings
						}`,
						'_Total Price': `${formSubmit.dataset.productPrice}`,
					},
			  }
			: null;

		let items = [
			{
				id: formSubmit.dataset.addId,
				quantity: form.querySelector('[name="quantity"]')
					? form.querySelector('[name="quantity"]').value
					: 1,
				...customizeProperties,
			},
		];

		if (form.classList.contains('is-customizable')) {
			let customizerFormRequired = form.querySelectorAll(
				'.comp-accordion.required'
			);
			let isComplete = !document.querySelectorAll(
				'.comp-accordion.required:not(.is-complete)'
			).length;

			if (isComplete) {
				form.classList.remove('is-error');

				if (formSubmit.hasAttribute('data-gift-addon-id')) {
					items.unshift({
						id: formSubmit.dataset.giftAddonId,
						quantity: 1,
						properties: {
							_Addon: 'Gift Wrap Addon',
							_CustomizeId: `${formSubmit.dataset.addId}`,
						},
					});
				}

				if (formSubmit.hasAttribute('data-back-addon-id')) {
					items.unshift({
						id: formSubmit.dataset.backAddonId,
						quantity: 1,
						properties: {
							_Addon: 'Back Message Addon',
							_CustomizeId: `${formSubmit.dataset.addId}`,
						},
					});
				}

				if (formSubmit.hasAttribute('data-front-shadow-addon-id')) {
					items.unshift({
						id: formSubmit.dataset.frontShadowAddonId,
						quantity: 1,
						properties: {
							_Addon: 'Back Shadow Addon',
							_CustomizeId: `${formSubmit.dataset.addId}`,
						},
					});
				}

				if (formSubmit.hasAttribute('data-back-shadow-addon-id')) {
					items.unshift({
						id: formSubmit.dataset.backShadowAddonId,
						quantity: 1,
						properties: {
							_Addon: 'Back Shadow Addon',
							_CustomizeId: `${formSubmit.dataset.addId}`,
						},
					});
				}

				if (formSubmit.hasAttribute('data-base-shadow-addon-id')) {
					items.unshift({
						id: formSubmit.dataset.baseShadowAddonId,
						quantity: 1,
						properties: {
							_Addon: 'Base Shadow Addon',
							_CustomizeId: `${formSubmit.dataset.addId}`,
						},
					});
				}

				addItem(items);
			} else {
				form.classList.add('is-error');
				form.querySelector('.customizer-submit-error').innerHTML =
					'Must complete all fields';
				customizerFormRequired.forEach((el) => {
					!el.classList.contains('is-complete')
						? el.classList.add('is-incomplete')
						: '';
				});
			}
		} else {
			addItem(items);
		}
		// Sean Add - Refresh the savings tally
		// reloadCartData();

		// End Sean Add



	});
};

const initBlogIndex = () => {
	if (document.querySelector('.blog-pagination-next')) {
		let infiniteScroll = new InfiniteScroll('.blog-load-more', {
			path: '.blog-pagination-next',
			append: '.blog-post',
			button: '.blog-load-more-trigger',
			scrollThreshold: false,
			history: false,
		});

		infiniteScroll.on('last', (body, path) => {
			let loadMoreTrigger = document.querySelector('.blog-load-more-trigger');

			loadMoreTrigger.style.display = 'block';
			loadMoreTrigger.disabled = true;
			loadMoreTrigger.innerHTML = 'You’ve reached the end';
		});
	}
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');
	const gateContent = document.querySelector('.account-gate');
	const resetPasswordTrigger = document.querySelector(
		'.reset-password-trigger'
	);
	const resetPasswordCancel = document.querySelector('.reset-password-cancel');

	if (gateWrapper) {
		resetPasswordTrigger.addEventListener('click', (event) => {
			event.preventDefault();

			// update URL with hash
			history.pushState(null, null, '#recover');

			// assign active state
			root.classList.add('reset-password-active');

			// update wrapper height to fit account reset form
			gateWrapper.style.height =
				document.querySelector('.account-reset').offsetHeight;

			// focus on email field
			document.querySelector('#account-recover-email').focus();
		});

		if (resetPasswordCancel) {
			resetPasswordCancel.addEventListener('click', (event) => {
				event.preventDefault();

				// remove has from URL
				history.pushState(null, null, ' ');

				// remove active state from root
				root.classList.remove('reset-password-active');

				// update wrapper height to fit account reset form
				gateWrapper.style.height = gateContent.offsetHeight;
			});
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			resetPasswordTrigger.click();
		}

		// set initial height
		gateWrapper.style.height = gateContent.offsetHeight;
	}
};

const initProductIndex = () => {
	if (document.querySelector('.collection-toolbar')) {
		//collection products filter
		const collectionProducts = document.querySelector(
			'.collection-content-container'
		);
		const collectionProductsGrid = collectionProducts.querySelector(
			'.collection-products_grid'
		);
		const toolbar = document.querySelector('.collection-toolbar');
		const toolbarInner = toolbar.querySelector('.collection-toolbar_inner');
		const toolbarDisplay = toolbar.querySelector('.collection-toolbar_display');
		const toolbarSort = toolbar.querySelector('.filter-sort');
		// toolbar and product filtering/sorting

		const toolbarRefresh = () => {
			let urlParams = new URLSearchParams(window.location.search);
			let urlParamsSort = urlParams.get('sort_by');

			if (!toolbar) return false;

			//construct sort combobox trigger default
			toolbar
				.querySelector('.combobox-input')
				.classList.add('combobox-input-value');

			//determine active state for sort
			if (urlParamsSort && urlParamsSort != 'manual') {
				toolbar.querySelectorAll('[data-sort-trigger]').forEach((item) => {
					item.classList.remove('is-active');
				});

				toolbar
					.querySelector(`[data-sort-trigger="${urlParamsSort}"]`)
					.classList.add('is-active');
				toolbar.querySelector(
					'.combobox-input .combobox-input-value'
				).innerText = toolbar.querySelector(
					`[data-sort-trigger="${urlParamsSort}"]`
				).innerText;
			}

			// determine active filters
			let filterActiveTerms = [];

			toolbar.querySelectorAll('[data-filter-trigger]').forEach((item) => {
				let filterIsActive = item.closest('li').classList.contains('is-active');

				//create key value pairs of type of filter and value
				let filterObj = {};
				if (filterIsActive) {
					Object.assign(filterObj, {
						type: item.dataset.filterType,
						value: item.dataset.filterTrigger,
					});
					filterActiveTerms.push(filterObj);
					item
						.closest('li')
						.querySelector('input[type="checkbox"]').checked = true;
				}
			});

			//group filter by type for display(turn object to array)
			let filterTermsGroup = Object.entries(
				filterActiveTerms.reduce(function (r, a) {
					r[a.type] = r[a.type] || [];
					r[a.type].push(a);
					return r;
				}, Object.create(null))
			);

			let filterTermsGroupArr = [];
			filterTermsGroup.forEach((group) => {
				filterTermsGroupArr.push(group);
			});

			if (filterActiveTerms.length) {
				// create toolbar current HTML
				toolbarDisplay.innerHTML = `
				${filterTermsGroupArr
					.map(
						(group) =>
							`<div class="f-h f-a-c f-j-s" data-filter-display="${
								group[0]
							}"><ul>${group[1]
								.map(
									(item) =>
										`<li class="cursor-hover" data-filter-clear-trigger="${
											item.value
										}">
						<button ${
							group[0] == 'color'
								? `data-swatch-color="${formatHandleize(item.value)}"`
								: ''
						} class="t-l-2">${group[0] != 'color' ? item.value : ''}</button>
					</li>`
								)
								.join('')}</ul>

				<button	class="t-l-2" data-filter-group-clear-trigger="${
					group[0]
				}" aria-label="Clear filter display">
				Clear All</button></div>`
					)
					.join('')}`;

				toolbarDisplay.classList.add('is-active');
			} else {
				// else, clear toolbar
				toolbarDisplay.innerHTML = '';
				toolbarDisplay.classList.remove('is-active');
			}
		};

		const productRefresh = () => {
			initLoadingBar('start');

			// fade out product grid
			collectionProductsGrid
				? collectionProductsGrid.classList.add('css_fade_out')
				: '';
			// generate filter URL
			let filterActiveTerms = [];
			let sortActiveTerm =
				toolbarSort.querySelector('.combobox-option.is-active') &&
				toolbarSort
					.querySelector('.combobox-option.is-active')
					.getAttribute('data-sort-trigger') != null
					? toolbarSort.querySelector('.combobox-option.is-active').dataset
							.sortTrigger
					: false;

			toolbar
				.querySelectorAll('li.is-active input[type="checkbox"]')
				.forEach((item) => {
					let tag = item ? item.value : '';
					filterActiveTerms.push(tag);
				});

			let filterUrl = `/collections/${collectionProducts.dataset.collectionId}${
				filterActiveTerms.length ? '?' + filterActiveTerms.join('&') : ''
			}${
				sortActiveTerm && sortActiveTerm != 'manual'
					? `${filterActiveTerms.length ? '&' : '?'}sort_by=${sortActiveTerm}`
					: ''
			}`;

			// trigger ajax request for products
			fetch(filterUrl)
				.then(function (response) {
					initLoadingBar('move');

					return response.text();
				})
				.then((data) => {
					// convert the HTML string into a document object
					let parser = new DOMParser();
					let dataDoc = parser.parseFromString(data, 'text/html');
					history.pushState({}, '', filterUrl);

					// refresh toolbar
					toolbarRefresh();
					// replace products
					let dataCollectionProduct = dataDoc.querySelector(
						'.collection-content-container'
					);

					let dataCollectionProductGrid = dataDoc.querySelector(
						'.collection-products'
					);

					if (dataCollectionProduct && dataCollectionProductGrid) {
						collectionProducts.innerHTML = dataCollectionProduct.innerHTML;
					} else {
						collectionProducts.innerHTML = `<section class="collection-empty">
					<div class="c-4 type-spacing">
						<p class="t-b-1">There are no items matching your filters – reset the filters or try a different category to continue.</p>
						<button
							class="btn is-outline"
							data-filter-clear-trigger="all">
							Reset Filters</button>
					</div>
				</section>`;
					}

					// fade in product grid
					setTimeout(function () {
						collectionProductsGrid.classList.remove('css_fade_out');
					}, 10);

					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
					initLoadingBar('done');
				})
				.catch((error) => {
					console.error('Error:', error);
				});
		};

		on(
			'body',
			'change',
			'.filter-selector input[type="checkbox"], .filter-selector input[type="checkbox"] *',
			(e) => {
				const target = e.target;

				if (target.checked) {
					target.closest('li').classList.add('is-active');
					// target.closest('.filter-selector').classList.remove('is-active');
				} else {
					target.closest('li').classList.remove('is-active');
				}

				productRefresh();
			}
		);

		on('body', 'click', '[data-sort-trigger]', (e) => {
			let target = e.target.hasAttribute('data-sort-trigger')
				? e.target.closest('[data-sort-trigger]')
				: e.target;

			let dropdown = target.closest('.combobox-menu');

			dropdown.querySelectorAll('[data-sort-trigger]').forEach((el) => {
				el.classList.remove('is-active');
			});
			target.classList.add('is-active');

			productRefresh(target.closest('.collection-content-container'));
		});

		on('body', 'click', '[data-filter-clear-trigger]', (e) => {
			let target = e.target;
			let targetFilter = toolbar
				.querySelector(
					`[data-filter-trigger="${target.dataset.filterClearTrigger}"]`
				)
				.closest('li');

			targetFilter.classList.remove('is-active');
			targetFilter.querySelector('input[type="checkbox"]').checked = false;

			// if (e.target.dataset.filterClearTrigger == 'all') {
			// 	toolbar.querySelectorAll('[data-filter-trigger]').forEach((trigger) => {
			// 		let triggerSelector = trigger.closest('li');
			// 		if (triggerSelector.classList.contains('is-active')) {
			// 			triggerSelector.classList.remove('is-active');
			// 			triggerSelector.querySelector(
			// 				'input[type="checkbox"]'
			// 			).checked = false;
			// 		}
			// 	});
			// } else {
			// }
			productRefresh();
		});

		on('body', 'click', '[data-filter-group-clear-trigger]', (e) => {
			let target = e.target;
			let targetFilters = e.target
				.closest('[data-filter-display]')
				.querySelectorAll('[data-filter-clear-trigger]');

			targetFilters.forEach((filter) => {
				filter.click();
			});
		});

		// reset toolbar on load
		toolbarRefresh();

		//filter dropdowns
		const dropdowns = document.querySelectorAll('[data-dropdown]');

		on('body', 'click', '[data-dropdown-toggle]', (e) => {
			let target = e.target.closest('[data-dropdown]');
			if (!target.classList.contains('is-active')) {
				dropdowns.forEach((dropdown) => {
					dropdown.classList.remove('is-active');
				});
				target.classList.add('is-active');
				toolbar.classList.add('is-active');
			} else {
				target.classList.remove('is-active');
				toolbar.classList.remove('is-active');
			}
		});

		//click outside of filter
		document.addEventListener('click', (e) => {
			if (
				!e.target.classList.contains('filter-selector') &&
				!e.target.closest('.filter-selector') &&
				!e.target.classList.contains('combobox-selector') &&
				!e.target.closest('.combobox-selector')
			) {
				dropdowns.forEach((dropdown) => {
					dropdown.classList.remove('is-active');
				});
			}
		});
	}
};

const initProductSingle = () => {
	const productContainer = document.querySelector('.product-hero');
	let isCustomizable = productContainer.classList.contains('is-customizable')
		? true
		: false;

	//product description read more
	on('body', 'click', '.js-read-toggle', (e) => {
		e.target.closest('.content-description').classList.toggle('is-active');

		if (
			e.target.closest('.content-description').classList.contains('is-active')
		) {
			e.target.innerHTML = 'Read less';
		} else {
			e.target.innerHTML = 'Read more';
		}
	});

	//product customize
	if (isCustomizable) {
		const customizerRenderer = productContainer.querySelector(
			'.product-customizer-renderer'
		);
		let urlCurrent = window.location.href;
		let customizeSettingsArr = [];
		let availCustomSettingsArr = [];
		const availCustomSettings = productContainer.querySelectorAll(
			'[data-customize-title]'
		);

		let isDoubleSide = false;
		let isGiftWrap = false;
		let isFrontShadow = false;
		let isBackShadow = false;
		let isBaseShadow = false;

		availCustomSettings.forEach((setting) => {
			availCustomSettingsArr.push(setting.dataset.customizeTitle);
		});

		function customizeTextScale(trigger, textStyle = false) {
			let messageBlock = trigger
				.closest('.product-hero.is-customizable')
				.querySelector(
					`${
						trigger.dataset.customizeType == 'front-message-text'
							? '.customize-text-wrapper-front'
							: trigger.dataset.customizeType == 'back-message-text'
							? '.customize-text-wrapper-back'
							: '.customize-text-wrapper-front'
					}`
				);
				

			let messageText = messageBlock.querySelector(
				'.customize-text:not(.is-shadow)'
			);

			let productName = messageBlock.closest('.product-customizer-renderer')
				.dataset.customizeProduct;

			let containerScaleX = productName.includes('flavia')
				? 0.72
				: productName.includes('baby')
				? 0.2
				: productName.includes('bodega')
				? 0.3
				: productName.includes('rolling')
				? 0.35
				: productName.includes('tabletop')
				? 0.35
				: 0.55; //custom slim
			// let containerScaleY = productName.includes('flavia')
			// 	? 0.5
			// 	: productName.includes('bodega')
			// 	? 0.3
			// 	: productName.includes('tabletop')
			// 	? 0.2
			// 	: 0.6; //custom slim

			let containerScaleY =
				textStyle == 'fresh-script' && productName.includes('flavia')
					? 0.4
					: productName.includes('flavia')
					? 0.7
					: productName.includes('tray')
					? 0.8
					: productName.includes('rolling')
					? 0.5
					: productName.includes('bodega')
					? 0.3
					: productName.includes('tabletop')
					? 0.4
					: textStyle == 'fresh-script' && productName.includes('slim-jean')
					? 0.5
					: 0.7; //custom slim

			function fitText() {
				const containerWidth = messageBlock.offsetWidth * containerScaleX;
				const containerHeight = messageBlock.offsetHeight * containerScaleY;
				const textWidth = messageText.offsetWidth;
				const textHeight = messageText.offsetHeight;
				const scaleX = containerWidth / textWidth;
				const scaleY = containerHeight / textHeight;
				const scale = Math.min(scaleX, scaleY);
				messageBlock
					.querySelectorAll('.customize-text .customize-text-scale')
					.forEach((textScale) => {
						textScale.style.transform = `scale(${scale})`;
					});
			}

			window.addEventListener('resize', fitText);
			fitText();
		}

		function updateCustomizeText(trigger) {
			let type = trigger.dataset.customizeType;
			let value =
				trigger.dataset.customizeInput == 'radio'
					? trigger.dataset.customizeValue
					: trigger.value;

			switch (type) {
				case 'base-message':
					customizerRenderer.dataset.baseMessage = value;
					break;

				case 'message-color':
					customizerRenderer.dataset.messageColor = value;
					let textWrapper = customizerRenderer.querySelector(
						'.customize-text:not(.is-shadow)'
					);
					if (value.includes('confetti')) {
						textWrapper.classList.add('is-confetti');
					} else {
						textWrapper.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapper.classList.add('is-glitter');
					} else {
						textWrapper.classList.remove('is-glitter');
					}

					break;

				case 'message-style':
					customizerRenderer.dataset.messageFont = value;
					break;

				case 'base-message-shadow':
					customizerRenderer.dataset.baseMessageShadow = value;
					let textWrapperShadow = customizerRenderer.querySelector(
						'.customize-text.is-shadow'
					);
					if (value.includes('confetti')) {
						textWrapperShadow.classList.add('is-confetti');
					} else {
						textWrapperShadow.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapperShadow.classList.add('is-glitter');
					} else {
						textWrapperShadow.classList.remove('is-glitter');
					}

					break;

				case 'front-message-text':
					customizerRenderer.dataset.frontText = value;
					break;

					case 'front-message-second-line-text':
						customizerRenderer.dataset.frontText = value;
						break;

				case 'front-message-color':
					customizerRenderer.dataset.frontColor = value;
					let textWrapperFront = customizerRenderer.querySelector(
						'.customize-text-wrapper-front .customize-text:not(.is-shadow)'
					);
					if (value.includes('confetti')) {
						textWrapperFront.classList.add('is-confetti');
					} else {
						textWrapperFront.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapperFront.classList.add('is-glitter');
					} else {
						textWrapperFront.classList.remove('is-glitter');
					}

					break;

				case 'front-message-style':
					customizerRenderer.dataset.frontFont = value;
					break;

				case 'front-message-shadow':
					customizerRenderer.dataset.frontShadowColor = value;
					const textWrapperFrontShadow = customizerRenderer.querySelector(
						'.customize-text-wrapper-front .customize-text.is-shadow'
					);
					if (value.includes('confetti')) {
						textWrapperFrontShadow.classList.add('is-confetti');
					} else {
						textWrapperFrontShadow.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapperFrontShadow.classList.add('is-glitter');
					} else {
						textWrapperFrontShadow.classList.remove('is-glitter');
					}

					break;

				case 'back-message-text':
					customizerRenderer.dataset.backText = value;
					break;

				case 'back-message-color':
					customizerRenderer.dataset.backColor = value;
					let textWrapperBack = customizerRenderer.querySelector(
						'.customize-text-wrapper-back .customize-text:not(.is-shadow)'
					);
					if (value.includes('confetti')) {
						textWrapperBack.classList.add('is-confetti');
					} else {
						textWrapperBack.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapperBack.classList.add('is-glitter');
					} else {
						textWrapperBack.classList.remove('is-glitter');
					}

					break;

				case 'back-message-style':
					customizerRenderer.dataset.backFont = value;
					break;

				case 'back-message-shadow':
					customizerRenderer.dataset.backShadowColor = value;
					let textWrapperBackShadow = customizerRenderer.querySelector(
						'.customize-text.is-shadow'
					);
					if (value.includes('confetti')) {
						textWrapperBackShadow.classList.add('is-confetti');
					} else {
						textWrapperBackShadow.classList.remove('is-confetti');
					}

					if (value.includes('glitter')) {
						textWrapperBackShadow.classList.add('is-glitter');
					} else {
						textWrapperBackShadow.classList.remove('is-glitter');
					}
					break;
			}

			if (
				type == 'base-message' ||
				type == 'front-message-text' ||
				type == 'front-message-second-line-text' ||
				type == 'back-message-text'
			) {
				let isSingle =
					type == 'base-message' || type == 'front-message-text' ? true : false;

				customizerRenderer
					.querySelectorAll(
						`${
							isSingle
								? '.customize-text-wrapper-front .customize-text .customize-text-scale'
								: '.customize-text-wrapper-back .customize-text .customize-text-scale'
						}`
					)
					.forEach((text) => {
						text.innerText = value;
					});
				customizeTextScale(
					trigger,
					`${
						trigger
							.closest('[data-customizer]')
							.querySelector('[data-swatch-style="fresh-script"]') &&
						trigger
							.closest('[data-customizer]')
							.querySelector('[data-swatch-style="fresh-script"]').checked
							? 'fresh-script'
							: false
					}`
				);
				// customizeTextScale(trigger, isSingle);
			}
		}

		function updateCustomizerUrl(trigger) {
			let inputType = trigger.dataset.customizeInput;

			//update url if is radio pass the handleized value
			let param = `${trigger.dataset.customizeType}=${
				inputType == 'radio' ? trigger.dataset.customizeValue : trigger.value
			}`;

			//update gift wrap and back message conditions
			if (inputType == 'checkbox') {
				function addCustomizerAddon(trigger, idAttr) {
					let customizeId = trigger.dataset.customizeAddonId;
					productSubmit.setAttribute(`${idAttr}`, customizeId);
					trigger.value = true;
					param = `${trigger.dataset.customizeType}=true`;
				}

				function removeCustomizerAddon(trigger, idAttr) {
					productSubmit.removeAttribute(`${idAttr}`);
					trigger.value = false;
					param = `${trigger.dataset.customizeType}=false`;
				}

				if (
					!isDoubleSide &&
					trigger.dataset.customizeType == 'add-back-message'
				) {
					addCustomizerAddon(trigger, 'data-back-addon-id');
					isDoubleSide = true;
				} else if (
					isDoubleSide &&
					trigger.dataset.customizeType == 'add-back-message'
				) {
					//remove back text shadow if is checked
					let backShadowTrigger = trigger
						.closest('.customizer-back')
						.querySelector(
							'[data-customize-addon="back-message-shadow-addon"]'
						);
					backShadowTrigger.checked
						? trigger
								.closest('.customizer-back')
								.querySelector(
									'[data-customize-addon="back-message-shadow-addon"]'
								)
								.click()
						: '';

					//flip customizer image if is on back side
					if (
						trigger
							.closest('.product-hero')
							.querySelector('.hero-images')
							.classList.contains('customizer-is-flipped')
					) {
						trigger
							.closest('.product-hero')
							.querySelector('.hero-images .js-toggle-flip')
							.click();
					}
					removeCustomizerAddon(trigger, 'data-back-addon-id');
					isDoubleSide = false;
				}

				if (!isGiftWrap && trigger.dataset.customizeType == 'add-gift-wrap') {
					addCustomizerAddon(trigger, 'data-gift-addon-id');
					isGiftWrap = true;
				} else if (
					isGiftWrap &&
					trigger.dataset.customizeType == 'add-gift-wrap'
				) {
					removeCustomizerAddon(trigger, 'data-gift-addon-id');
					isGiftWrap = false;
				}

				if (
					!isFrontShadow &&
					trigger.dataset.customizeType == 'add-front-message-shadow'
				) {
					if (
						!trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					addCustomizerAddon(trigger, 'data-front-shadow-addon-id');
					isFrontShadow = true;
				} else if (
					isFrontShadow &&
					trigger.dataset.customizeType == 'add-front-message-shadow'
				) {
					//close accordion under front shadow if not closed
					if (
						trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					removeCustomizerAddon(trigger, 'data-front-shadow-addon-id');
					isFrontShadow = false;
				}

				if (
					!isBackShadow &&
					trigger.dataset.customizeType == 'add-back-message-shadow'
				) {
					if (
						!trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					addCustomizerAddon(trigger, 'data-back-shadow-addon-id');
					isBackShadow = true;
				} else if (
					isBackShadow &&
					trigger.dataset.customizeType == 'add-back-message-shadow'
				) {
					//close accordion under back shadow if not closed
					if (
						trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					removeCustomizerAddon(trigger, 'data-back-shadow-addon-id');
					isBackShadow = false;
				}

				if (
					!isBaseShadow &&
					trigger.dataset.customizeType == 'add-base-message-shadow'
				) {
					if (
						!trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					addCustomizerAddon(trigger, 'data-base-shadow-addon-id');
					isBaseShadow = true;
				} else if (
					isBaseShadow &&
					trigger.dataset.customizeType == 'add-base-message-shadow'
				) {
					//close accordion under front shadow if not closed
					if (
						trigger
							.closest('.customizer-shadow')
							.querySelector('.comp-accordion')
							.classList.contains('is-expanded')
					) {
						trigger
							.closest('.customizer-shadow')
							.querySelector('.js-toggle-accordion')
							.click();
					}
					removeCustomizerAddon(trigger, 'data-base-shadow-addon-id');
					isBaseShadow = false;
				}
			}

			//find duplicate and remove before adding new settings
			let duplicateSetting = customizeSettingsArr.find((v) =>
				v.includes(trigger.dataset.customizeType)
			);

			duplicateSetting != undefined
				? customizeSettingsArr.splice(
						customizeSettingsArr.indexOf(duplicateSetting),
						1
				  )
				: '';

			customizeSettingsArr.push(param);

			customizerRenderer.dataset.customizeSettings =
				customizeSettingsArr.join('&');

			//remove everything after query and update url
			urlCurrent = urlCurrent.split('?')[0];
			history.replaceState(
				null,
				'',
				`${urlCurrent}?${customizerRenderer.dataset.customizeSettings}`
			);
		}

		function updateLabel(trigger, onloadValue, onload) {
			let target = trigger.closest('.comp-accordion');

			onload ? (trigger.value = onloadValue) : '';
			if (target != null) {
				if (trigger.value == '') {
					target.querySelector('.accordion-label').innerHTML = 'Enter Text';
					target.classList.remove('is-complete');
				} else {
					onload
						? target.classList.add('is-complete-onload')
						: target.classList.remove('is-complete-onload');
					target.querySelector('.accordion-label').innerHTML = trigger.value;
					target.classList.add('is-complete');
					target.classList.remove('is-incomplete');
				}
			}
		}

		function activeCustomizer(setting, value) {
			let isText =
				setting == 'front-message-text' ||
				setting == 'front-message-second-line-text' ||
				setting == 'back-message-text' ||
				setting == 'base-message' ||
				setting == 'gift-wrap-message'
					? true
					: false;

			let isCheckbox =
				setting == 'add-gift-wrap' ||
				setting == 'add-back-message' ||
				setting == 'add-front-message-shadow' ||
				setting == 'add-back-message-shadow' ||
				setting == 'add-base-message-shadow'
					? true
					: false;

			let hasGiftWrap = '';
			let hasBackMessage = '';
			let hasFrontShadow = '';
			let hasBackShadow = '';
			let hasBaseShadow = '';

			if (isCheckbox && setting == 'add-gift-wrap') {
				hasGiftWrap = value == 'true' ? true : false;
			}

			if (isCheckbox && setting == 'add-back-message') {
				hasBackMessage = value == 'true' ? true : false;
			}

			if (isCheckbox && setting == 'add-front-message-shadow') {
				hasFrontShadow = value == 'true' ? true : false;
			}

			if (isCheckbox && setting == 'add-back-message-shadow') {
				hasBackShadow = value == 'true' ? true : false;
			}

			if (isCheckbox && setting == 'add-base-message-shadow') {
				hasBaseShadow = value == 'true' ? true : false;
			}

			let activeOption =
				!isText && !isCheckbox
					? document.getElementById(`${setting + value}`)
					: document.getElementById(`${setting}`);

			function addCustomizerAddon(activeOption, idAttr, rootClass) {
				activeOption.checked = true;
				activeOption.value = 'true';
				productSubmit.setAttribute(
					`${idAttr}`,
					activeOption.dataset.customizeAddonId
				);
				root.classList.add(`${rootClass}`);
			}

			function removeCustomizerAddon(activeOption, idAttr, rootClass) {
				activeOption.checked = false;
				activeOption.value = 'false';
				productSubmit.removeAttribute(`${idAttr}`);
				root.classList.remove(`${rootClass}`);
			}

			if (isCheckbox) {
				if (hasGiftWrap && hasGiftWrap != '') {
					addCustomizerAddon(
						activeOption,
						'data-gift-addon-id',
						'customizer-gift-wrap'
					);
					updateCustomizePrice(activeOption);
					isGiftWrap = true;
				} else if (hasGiftWrap != '') {
					removeCustomizerAddon(
						activeOption,
						'data-gift-addon-id',
						'customizer-gift-wrap'
					);
					isGiftWrap = false;
				}

				if (hasBackMessage && hasBackMessage !== '') {
					addCustomizerAddon(
						activeOption,
						'data-back-addon-id',
						'customizer-double-side'
					);
					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.add('required');
						});
					updateCustomizePrice(activeOption);
					isDoubleSide = true;
				} else if (hasBackMessage !== '') {
					removeCustomizerAddon(
						activeOption,
						'data-back-addon-id',
						'customizer-double-side'
					);

					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.remove('required');
						});
					isDoubleSide = false;
				}

				if (hasFrontShadow && hasFrontShadow !== '') {
					addCustomizerAddon(
						activeOption,
						'data-front-shadow-addon-id',
						'front-message-shadow-addon'
					);
					activeOption
						.closest('.customizer-shadow')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.add('required');
						});
					updateCustomizePrice(activeOption);
					isFrontShadow = true;
				} else if (hasFrontShadow !== '') {
					removeCustomizerAddon(
						activeOption,
						'data-front-shadow-addon-id',
						'front-message-shadow-addon'
					);

					activeOption
						.closest('.customizer-shadow')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.remove('required');
						});
					isFrontShadow = false;
				}

				if (hasBackShadow && hasBackShadow !== '') {
					addCustomizerAddon(
						activeOption,
						'data-back-shadow-addon-id',
						'back-message-shadow-addon'
					);
					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.add('required');
						});
					updateCustomizePrice(activeOption);
					isBackShadow = true;
				} else if (hasBackShadow !== '') {
					removeCustomizerAddon(
						activeOption,
						'data-back-shadow-addon-id',
						'back-message-shadow-addon'
					);

					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.remove('required');
						});
					isBackShadow = false;
				}

				if (hasBaseShadow && hasBaseShadow !== '') {
					addCustomizerAddon(
						activeOption,
						'data-base-shadow-addon-id',
						'base-message-shadow-addon'
					);
					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.add('required');
						});
					updateCustomizePrice(activeOption);
					isBaseShadow = true;
				} else if (hasBaseShadow !== '') {
					removeCustomizerAddon(
						activeOption,
						'data-base-shadow-addon-id',
						'base-message-shadow-addon'
					);

					activeOption
						.closest('[data-customizer]')
						.querySelectorAll('.comp-accordion')
						.forEach((el) => {
							el.classList.remove('required');
						});
					isBaseShadow = false;
				}
			} else if (activeOption) {
				!isText ? (activeOption.checked = true) : '';
				updateLabel(activeOption, value, true);
				updateCustomizeText(activeOption);
			}
		}

		const customizerRefresh = () => {
			let urlParams = new URLSearchParams(window.location.search);
			let urlParamsSetting = '';

			//onload customize setting url & array
			customizerRenderer.dataset.customizeSettings = urlCurrent
				.split('?')
				.pop();
			customizerRenderer.dataset.customizeSettings
				.split('&')
				.forEach((param) => {
					customizeSettingsArr.push(param);
				});

			//loop through available options match url to set active state

			availCustomSettingsArr.forEach((setting) => {
				urlParamsSetting = urlParams.get(`${setting}`);
				if (urlParamsSetting && urlParamsSetting !== undefined) {
					activeCustomizer(setting, urlParamsSetting);
				}
			});
		};

		let variantSelected = [];
		const productSubmit = productContainer.querySelector('[data-add-id]');

		function updateCustomizeImage(trigger, onload) {
			const variantOptions = productContainer.querySelectorAll(
				'[data-variant-option]'
			);

			function updateVariantSelected(option, optionType) {
				if (optionType === 'base-color') {
					variantSelected[0] = option.dataset.variantOption;
				} else if (optionType === 'hardware-color') {
					variantSelected[1] = option.dataset.variantOption;
				} else if (optionType === 'border-color') {
					variantSelected[1] = option.dataset.variantOption;
				}
			}

			if (onload) {
				variantOptions.forEach((option) => {
					if (option.checked) {
						let optionType = option.dataset.customizeType;
						//onload get image
						updateVariantSelected(option, optionType);
					}
				});
			} else {
				let optionType = trigger.dataset.customizeType;
				updateVariantSelected(trigger, optionType);
			}

			let variantSelectedNew = variantSelected.filter((a) => a);
			let variantSelectedTitle = variantSelectedNew.join(' / '); // e.g. xs / black

			//  find corresponding variant title
			const variantSelectedOption = [
				...productContainer.querySelectorAll('.variant-value'),
			].find((element) => element.dataset.valueTitle === variantSelectedTitle);

			const customizeImage = productContainer.querySelector('.customize-image');

			if (variantSelected.length > 0 && variantSelectedOption) {
				customizeImage.setAttribute(
					'src',
					variantSelectedOption.dataset.valueImage
				);
				productSubmit.dataset.addId = variantSelectedOption.value;
			}
		}

		function updateCustomizePrice(target) {
			let productPrice = productSubmit.dataset.productPrice;
			let finalPrice = `${
				parseFloat(productPrice) -
				(target.checked
					? -1 * parseFloat(target.dataset.customizeAddonPrice)
					: 1 * parseFloat(target.dataset.customizeAddonPrice))
			}`;

			productSubmit.dataset.productPrice = finalPrice;
			productSubmit.querySelector(
				'.product-price'
			).innerHTML = `$${finalPrice}`;
		}

		//if has query parameter run refresher
		urlCurrent.indexOf('?') !== -1 ? customizerRefresh() : '';
		updateCustomizeImage('', true);

		on('body', 'click', '[data-customize-addon]', (e) => {
			let target = e.target;
			let type = e.target.dataset.customizeAddon;
			if (type == 'back-message-addon') {
				root.classList.toggle('customizer-double-side');

				//assign required state
				target
					.closest('[data-customizer]')
					.querySelectorAll('.comp-accordion')
					.forEach((el) => {
						el.classList.toggle('required');
					});
				updateCustomizerUrl(target);
				updateCustomizePrice(target);
			} else if (type == 'gift-wrap-addon') {
				root.classList.toggle('customizer-gift-wrap');
				updateCustomizerUrl(target);
				updateCustomizePrice(target);
			} else if (type == 'back-message-shadow-addon') {
				root.classList.toggle('back-message-shadow-addon');
				updateCustomizerUrl(target);
				updateCustomizePrice(target);
			} else if (type == 'front-message-shadow-addon') {
				root.classList.toggle('front-message-shadow-addon');
				updateCustomizerUrl(target);
				updateCustomizePrice(target);
			} else if (type == 'base-message-shadow-addon') {
				root.classList.toggle('base-message-shadow-addon');
				updateCustomizerUrl(target);
				updateCustomizePrice(target);
			}
		});

		on('body', 'click', '.js-toggle-flip', (e) => {
			let flipLabel = e.target.querySelector('.customizer-flip_label');
			const customizeRenderer = e.target.closest('.hero-images');
			if (customizeRenderer.classList.contains('customizer-is-flipped')) {
				customizeRenderer.classList.remove('customizer-is-flipped');
				flipLabel.innerText = 'Flip to back';
			} else {
				customizeRenderer.classList.add('customizer-is-flipped');
				flipLabel.innerText = 'Flip to front';
			}
		});

		on('body', 'click', '[data-variant-option]', (e) => {
			updateCustomizeImage(e.target, false);
		});

		on('body', 'click', '[data-customize-input="radio"]', (e) => {
			updateLabel(e.target, '', false);
			updateCustomizerUrl(e.target);
			updateCustomizeText(e.target);
			//update customize text scale
			if (e.target.hasAttribute('data-swatch-style')) {
				customizeTextScale(
					e.target
						.closest('[data-customizer]')
						.querySelector('[data-customize-input="text"]'),
					e.target.dataset.swatchStyle
				);
			}
		});

		on('body', 'keyup', '[data-customize-input="text"]', (e) => {
			updateCustomizerUrl(e.target);

			updateLabel(e.target, '', false);
			updateCustomizeText(e.target);
		});

		productContainer
			.querySelectorAll('[data-customize-input="radio"]')
			.forEach((input) => {
				if (input.checked) {
					updateCustomizerUrl(input);
					updateLabel(input, input.value, true);
					updateCustomizeText(input);
				}
			});

		productContainer
			.querySelectorAll('[data-customize-input="text"]')
			.forEach((input) => {
				if (input.value) {
					updateCustomizerUrl(input);
					updateLabel(input, input.value, true);
					updateCustomizeText(input);
				}
			});
	}

	//variant select (gift card etc.)
	on('body', 'click', '.js-variant-option', (e) => {
		let trigger = e.target;
		getSiblings(trigger.closest('li')).forEach((item) => {
			item.classList.remove('is-active');
		});
		trigger.closest('li').classList.add('is-active');

		let productSubmit = trigger
			.closest('.hero-content')
			.querySelector('[data-add-id]');

		if (trigger.dataset.inventory <= 0) {
			productSubmit.setAttribute('disabled', '');
			productSubmit.querySelector('.product-submit-label').innerHTML =
				'Sold out';
		} else {
			productSubmit.removeAttribute('disabled');
			productSubmit.querySelector('.product-submit-label').innerHTML =
				'Add to cart';
		}

		productSubmit.dataset.addId = trigger.dataset.optionId;
		productSubmit.querySelector('.product-price').innerHTML =
			trigger.dataset.price;


		// Sean ADD
		const activeButton = document.querySelector(
			'.content-variant ul li.is-active button'
		);

		if (activeButton) {
			const currentButton = activeButton.dataset.optionId;
			function matchThumbnail(currentButton) {
				return document.querySelector(
					`.thumbnail[data-variant-id="${currentButton}"]`
				);
			}
			const matchingThumbnail = matchThumbnail(currentButton);
			if (matchingThumbnail) {
				// matchingThumbnail.classList.add('active');
				matchingThumbnail.click();
			}
		}
		// End Sean Add

	});

	//magnify
	function magnify(magnifyImg, zoom) {
		let img, glass, w, h, bw;
		img = magnifyImg;

		/*create magnifier glass:*/
		glass = img.closest('.magnify-image').nextElementSibling;
		/*set background properties for the magnifier glass:*/
		glass.style.backgroundSize =
			img.width * zoom + 'px ' + img.height * zoom + 'px';
		bw = 3;
		glass.style.backgroundRepeat = 'no-repeat';
		w = glass.offsetWidth / 2;
		h = glass.offsetHeight / 2;
		/*execute a function when someone moves the magnifier glass over the image:*/
		glass.addEventListener('mousemove', moveMagnifier);
		img.addEventListener('mousemove', moveMagnifier);
		/*and also for touch screens:*/
		glass.addEventListener('touchmove', moveMagnifier);
		img.addEventListener('touchmove', moveMagnifier);
		function moveMagnifier(e) {
			var pos, x, y;
			/*prevent any other actions that may occur when moving over the image*/
			e.preventDefault();
			/*get the cursor's x and y positions:*/
			pos = getCursorPos(e);
			x = pos.x;
			y = pos.y;
			/*prevent the magnifier glass from being positioned outside the image:*/
			if (x > img.width * 1.5 - w / zoom) {
				x = img.width * 1.5 - w / zoom;
			}
			if (x < (w * 1.5) / zoom) {
				x = (w * 1.5) / zoom;
			}

			if (y > img.height * 1.5 - h / zoom) {
				y = img.height * 1.5 - h / zoom;
			}

			if (y < (h * 0.5) / zoom) {
				y = (h * 0.5) / zoom;
			}
			/*set the position of the magnifier glass:*/
			glass.style.left = x - w + 'px';
			glass.style.top = y - h + 'px';
			/*display what the magnifier glass "sees":*/
			glass.style.backgroundPosition =
				'-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
		}
		function getCursorPos(e) {
			var a,
				x = 0,
				y = 0;
			e = e || window.event;
			/*get the x and y positions of the image:*/
			a = img.getBoundingClientRect();
			/*calculate the cursor's x and y coordinates, relative to the image:*/
			x = e.pageX - a.left;
			y = e.pageY - a.top;
			/*consider any page scrolling:*/
			x = x - window.pageXOffset;
			y = y - window.pageYOffset;
			return { x: x, y: y };
		}
	}

	//load high res image when completed
	function loadMagnifyImg() {
		document.querySelectorAll('.magnify-image img').forEach((img) => {
			img.addEventListener(
				'load',
				(e) => {
					let imageUrl = img.src;
					let magnifyGlass = img.closest('.magnify-image').nextElementSibling;
					let preloaderImg = document.createElement('img');
					preloaderImg.src = imageUrl;
					preloaderImg.addEventListener(
						'load',
						(e) => {
							magnifyGlass.style.backgroundImage = `url(${imageUrl})`;
							preloaderImg = null;
						},
						false
					);
				},
				false
			);
		});
	}

	loadMagnifyImg();

	on('body', 'mouseover', '.magnify-image-container', (e) => {
		let target = e.target.closest('.magnify-image-container');
		magnify(target.querySelector('.magnify-image img'), 1.5);
		target.classList.add('is-active');
		root.classList.add('magnify-is-active');
	});

	on('body', 'mouseout', '.magnify-image-container', (e) => {
		e.target.closest('.magnify-image-container').classList.remove('is-active');
		root.classList.remove('magnify-is-active');
	});

	//fetch variant
	on('body', 'click', '.js-product-fetch', (e) => {
		let target = e.target.closest('.js-product-fetch');
		initLoadingBar('start');
		fetch(target.dataset.fetchUrl)
			.then((response) => {
				initLoadingBar('move');
				return response.text();
			})
			.then((data) => {
				let parser = new DOMParser();
				let dataHtml = parser.parseFromString(data, 'text/html');

				productContainer.innerHTML =
					dataHtml.querySelector('.product-hero').innerHTML;
				history.pushState(null, null, target.dataset.fetchUrl);
				initLoadingBar('done');
				initAccordions();
				initEmblaSlider();
				initPDPGallery();
				loadMagnifyImg();

				//open first accordion
				if (document.querySelectorAll('.comp-accordion').length > 0) {
					document
						.querySelectorAll('.comp-accordion')[0]
						.querySelector('.js-toggle-accordion')
						.click();
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});
};

const initFaq = () => {
	if (document.querySelectorAll('[data-faq-target]').length > 0) {
		document
			.querySelectorAll('[data-faq-target]')[0]
			.querySelector('.js-toggle-accordion')
			.click();
	}

	on('body', 'click', '[data-faq-trigger]', (e) => {
		let trigger = e.target.closest('[data-faq-trigger]');
		let activeTarget = document.querySelector(
			`[data-faq-target="${trigger.dataset.faqTrigger}"]`
		);
		getSiblings(trigger.closest('li')).forEach((el) => {
			el.classList.remove('is-active');
		});

		if (!trigger.closest('li').classList.contains('is-active')) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
		trigger.closest('li').classList.add('is-active');

		getSiblings(activeTarget).forEach((el) => {
			el.classList.contains('is-expanded')
				? el.querySelector('.js-toggle-accordion').click()
				: '';
		});

		setTimeout(() => {
			activeTarget.querySelector('.js-toggle-accordion').click();
		}, 800);
	});

	on('body', 'click', '[data-faq-target]', (e) => {
		let trigger = e.target.closest('[data-faq-target]');
		let activeTarget = document.querySelector(
			`[data-faq-trigger="${trigger.dataset.faqTarget}"]`
		);
		if (!trigger.classList.contains('is-expanded')) {
			activeTarget.closest('li').classList.remove('is-active');
		} else {
			document.querySelectorAll('[data-faq-trigger]').forEach((el) => {
				el.closest('li').classList.remove('is-active');
			});
			activeTarget.closest('li').classList.add('is-active');
		}
	});
};

const initFrontpage = () => {
	(function () {
		const items = [];
		const customizableProducts = document.querySelector('.customize-products');
		let productCards = document.querySelectorAll('.product-card-container');

		items.push(...shuffle(productCards));

		const doors = document.querySelectorAll('.slot-wrapper');

		on('body', 'click', '.js-spin', () => {
			spin();
		});

		function resizeSlot() {
			productCards = document.querySelectorAll('.product-card-container');
			productCards.forEach((card) => {
				card.style.width = doors[0].clientWidth + 'px';
				card.style.height = doors[0].clientHeight + 'px';
			});
			doors.forEach((door) => {
				door.querySelector('.slot-items').style.transform = `translateY(-${
					!customizableProducts.classList.contains('is-spun')
						? door.clientHeight
						: 0
				}px)`;
			});
		}
		window.addEventListener('resize', resizeSlot);

		function init(firstInit = true, duration = 1) {
			for (const [i, door] of doors.entries()) {
				const boxes = door.querySelector('.slot-items');
				const boxesClone = boxes.cloneNode(false);
				let pool = [];

				//divide array into 3, prevent overlap of items
				const n = 3;
				const result = [[], [], []];
				const boxesPerColumn = Math.ceil(items.length / n);

				for (let col = 0; col < n; col++) {
					for (let i = 0; i < boxesPerColumn; i++) {
						const value = items[i + col * boxesPerColumn];
						if (!value) continue; //avoid adding "undefined" values
						result[col].push(value);
					}
				}

				let arr = [];
				arr.push(...result[i]);
				pool.push(...shuffle(arr));

				const half = Math.ceil(pool.length / 3);
				pool = pool.slice(0, half);

				if (!firstInit) {
					const lastEl = Array.from(
						boxes.querySelectorAll('.product-card-container')
					).pop();

					pool.pop();
					pool.unshift(lastEl);

					door
						.closest('.slot-wrapper-container')
						.querySelector('.slot-wrapper.is-clone')
						.classList.add('is-fade');

					boxesClone.addEventListener(
						'transitionstart',
						() => {
							door.dataset.spinned = '0';

							//remove seamless transition duplicate slot
							setTimeout(() => {
								door
									.closest('.slot-wrapper-container')
									.querySelector('.slot-wrapper.is-clone')
									.remove();
							}, 800);
						},
						{ once: true }
					);

					boxesClone.addEventListener(
						'transitionend',
						() => {
							customizableProducts.classList.add('is-spun');
							boxesClone
								.querySelectorAll('.product-card-container')
								.forEach((box, index) => {
									if (index > 0) boxesClone.removeChild(box);
								});
							let cloneCurrentSlot = door.cloneNode(true);
							cloneCurrentSlot.classList.add('is-clone');
							cloneCurrentSlot
								.querySelector('.slot-items')
								.classList.add('is-settled');
							door
								.closest('.slot-wrapper-container')
								.appendChild(cloneCurrentSlot);
						},
						{ once: true }
					);
				}

				for (let i = pool.length - 1; i >= 0; i--) {
					let randNum = getRandomInt(0, pool.length - 1);
					const box = document.createElement('div');
					box.classList.add('product-card-container');
					box.style.width = door.clientWidth + 'px';
					box.style.height = door.clientHeight + 'px';
					if (i == 0 && !firstInit) {
						box.innerHTML = pool[0].innerHTML;
					} else {
						box.innerHTML = pool[randNum].innerHTML;
					}
					boxesClone.appendChild(box);
				}

				let transitionDuration = duration > 0 ? duration : 3;
				poolLength = pool.length;

				boxesClone.style.transitionDuration = `${duration > 0 ? duration : 3}s`;
				boxesClone.style.transform = `translateY(-${
					door.clientHeight * (pool.length - 1)
				}px)`;

				door.replaceChild(boxesClone, boxes);

				//add seamless transition duplicate slot
				if (firstInit) {
					let cloneCurrentSlot = door.cloneNode(true);
					cloneCurrentSlot.classList.add('is-clone');
					cloneCurrentSlot
						.querySelector('.slot-items')
						.classList.add('is-settled');
					door.closest('.slot-wrapper-container').appendChild(cloneCurrentSlot);
				}

				let spinTriggers = document.querySelectorAll('.js-spin');
				if (spinTriggers) {
					spinTriggers.forEach((el) => {
						el.classList.add('is-spinning');
					});

					setTimeout(() => {
						spinTriggers.forEach((el) => {
							el.classList.remove('is-spinning');
						});
					}, transitionDuration * 1000);
				}
			}
		}

		async function spin() {
			init(false, 3);
			for (const door of doors) {
				const boxes = door.querySelector('.slot-items');
				const duration = parseInt(boxes.style.transitionDuration);
				boxes.style.transform = 'translateY(0)';

				await new Promise((resolve) => setTimeout(resolve, duration * 100));
			}
		}

		function shuffle([...arr]) {
			let m = arr.length;
			while (m) {
				const i = Math.floor(Math.random() * m--);
				[arr[m], arr[i]] = [arr[i], arr[m]];
			}
			return arr;
		}
		init();
	})();
	//get all available customize product in the slot machine
	//change url to link to the product

	let customizeProducts = document.querySelectorAll(
		'.customize-products .product-card'
	);
	const customizeInput = document.querySelector('.typewriter-input input');

	function updateText(value) {
		let messageLength = customizeInput.value.length;
		customizeProducts = document.querySelectorAll(
			'.customize-products .product-card'
		);
		customizeProducts.forEach((product) => {
			let renderer = product.querySelector('.product-customizer-renderer');
			let messageMaxLength = parseInt(renderer.dataset.maxLength);
			let messageText = renderer.querySelector(
				'.customize-text-wrapper-front .customize-text .customize-text-scale'
			);
			//check if exceed maximum
			if (value.length > parseInt(renderer.dataset.maxLength)) {
				renderer.classList.add('is-error');
			} else {
				//render text
				messageText.innerHTML = value;
				renderer.classList.remove('is-error');
			}

			//update url
			let productUrl = product.querySelector('.card-url');
			productUrl.setAttribute('href', '');
			productUrl.setAttribute(
				'href',
				`/products/${renderer.dataset.customizeProduct}?variant=${
					product.dataset.productId
				}&${
					renderer.dataset.customizeSide == 'single'
						? 'base-message'
						: 'front-message-text'
				}=${
					renderer.querySelector(
						'.customize-text-wrapper-front .customize-text .customize-text-scale'
					).textContent
				}`
			);
			if (messageMaxLength > messageLength) {
				//scale text
				let productName = renderer.dataset.customizeProduct;
				let containerScaleX = productName.includes('flavia')
					? 0.6
					: productName.includes('baby')
					? 0.2
					: productName.includes('bodega')
					? 0.3
					: productName.includes('tabletop')
					? 0.35
					: 0.45; //custom slim
				let containerScaleY = productName.includes('flavia')
					? 0.5
					: productName.includes('bodega')
					? 0.3
					: productName.includes('tabletop')
					? 0.2
					: 0.6; //custom slim
				function fitText() {
					const containerWidth = renderer.offsetWidth * containerScaleX;
					const containerHeight = renderer.offsetHeight * containerScaleY;
					const textWidth = messageText.offsetWidth;
					const textHeight = messageText.offsetHeight;
					const scaleX = containerWidth / textWidth;
					const scaleY = containerHeight / textHeight;
					const scale = Math.min(scaleX, scaleY);
					renderer
						.querySelectorAll('.customize-text .customize-text-scale')
						.forEach((textScale) => {
							textScale.style.transform = `scale(${scale})`;
						});
				}

				window.addEventListener('resize', fitText);
				fitText();
			}
		});
	}

	on('body', 'keyup', '.typewriter-input input', (e) => {
		updateText(e.target.value);
	});
};

const initAbout = () => {
	window.onbeforeunload = function () {
		window.scrollTo(0, 0);
	};
	const aboutContent = document.querySelector('.about-left_content');
	const aboutContentBlocks = aboutContent.querySelectorAll(
		'.about-left_content-block'
	);
	let aboutContentWidth = aboutContent.querySelector(
		'.about-left_content-block'
	).clientWidth;
	let scrollDirection = 'left';
	let currentPosition = 0;
	let oldScroll = 0;
	let scrollX = 0;
	let scrollXSpy = 0;

	function aboutContentTranslate(scrollAmount, times = 1) {
		let translate = `${
			parseFloat(currentPosition) +
			(scrollDirection == 'left'
				? 1 * times * parseFloat(aboutContentWidth + 60)
				: -1 * times * parseFloat(aboutContentWidth + 60))
		}`;

		currentPosition = parseInt(translate);
		aboutContent.style.transform = `translate3d(${translate}px, 0, 0)`;

		oldScroll = parseInt(
			`${
				parseFloat(oldScroll) +
				(scrollDirection == 'left'
					? -1 * times * parseFloat(scrollAmount)
					: 1 * times * parseFloat(scrollAmount))
			}`
		);
	}

	const stickyContainer = document.querySelector('.sticky-container');
	let stickyContainerHeight = 0;

	function init() {
		setStickyContainersSize();
		bindEvents();
	}

	function bindEvents() {
		window.addEventListener('wheel', wheelHandler);
	}

	function setStickyContainersSize() {
		stickyContainerHeight =
			stickyContainer.querySelector('.sticky-container-inner').scrollWidth *
			1.01;
		!isTablet
			? (stickyContainer.style.height = `${stickyContainerHeight}px`)
			: (stickyContainer.style.height = 'unset');
	}

	function isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return rect.top <= 0 && rect.bottom > document.documentElement.clientHeight;
	}

	function wheelHandler(e) {
		const containerInViewPort = Array.from(
			document.querySelectorAll('.sticky-container')
		).filter(function (container) {
			return isElementInViewport(container);
		})[0];

		let minScroll = 0;
		let maxScrollX = stickyContainerHeight;
		//determine scroll amount for content switch
		let scrollAmount = Math.ceil(maxScrollX / aboutContentBlocks.length - 1);

		if (!containerInViewPort) {
			return;
		}

		let isPlaceHolderBelowTop =
			containerInViewPort.offsetTop < document.documentElement.scrollTop;
		let isPlaceHolderBelowBottom =
			containerInViewPort.offsetTop + containerInViewPort.offsetHeight >
			document.documentElement.scrollTop;
		let g_canScrollHorizontally =
			isPlaceHolderBelowTop && isPlaceHolderBelowBottom;

		if (g_canScrollHorizontally) {
			containerInViewPort.querySelector('.sticky-container-inner').scrollLeft +=
				e.deltaY * 0.5;
			scrollX += e.deltaY * 0.5;
			scrollXSpy += e.deltaY * 0.5;
			if (e.deltaY < 0) {
				scrollDirection = 'left';
			} else if (e.deltaY > 0) {
				scrollDirection = 'right';
			}

			if (scrollX > maxScrollX - window.innerWidth * 0.65) {
				scrollX = maxScrollX - window.innerWidth * 0.65;
			} else if (scrollX < minScroll) {
				scrollX = minScroll;
			}

			if (
				parseInt(Math.abs(scrollX - oldScroll)) >= scrollAmount &&
				maxScrollX > oldScroll
			) {
				aboutContentTranslate(scrollAmount);
			}
		}
	}

	!isTablet ? init() : '';

	window.addEventListener('resize', () => {
		aboutContentWidth = aboutContent.querySelector(
			'.about-left_content-block'
		).clientWidth;
		setStickyContainersSize();
		!isTablet ? init() : '';
	});

	const scrollContainer = document.querySelector('.sticky-container-inner');
	let scrollAmountTotal = 0;

	on('body', 'click', '[data-about-section-trigger]', (e) => {
		e.preventDefault();

		const trigger = e.target.closest('[data-about-section-trigger]');

		//trigger active
		getSiblings(trigger).forEach((trigger) => {
			trigger.classList.remove('is-active');
		});

		trigger.classList.add('is-active');

		const target = document.querySelector(
			`[data-about-section-target=${e.target.dataset.aboutSectionTrigger}]`
		);

		if (target) {
			const leftPosition = parseInt(target.offsetLeft);
			let minScroll = 0;
			let maxScrollX = stickyContainerHeight;
			//determine scroll amount for content switch
			let scrollAmount = Math.ceil(maxScrollX / aboutContentBlocks.length);
			//takes us to the element:
			scrollContainer.scrollTo({
				top: 0,
				left: leftPosition,
				behavior: 'smooth',
			});

			leftPosition > oldScroll
				? (scrollDirection = 'right')
				: (scrollDirection = 'left');

			let x = scrollDirection == 'left' ? scrollAmount : 0;

			scrollAmountTotal = Math.abs(leftPosition - x - oldScroll);
			let times = Math.ceil(scrollAmountTotal / scrollAmount - 1);
			scrollX = leftPosition;
			scrollXSpy = leftPosition;

			if (scrollX > maxScrollX) {
				scrollX = maxScrollX;
			} else if (scrollX < minScroll) {
				scrollX = minScroll;
			}

			scrollContainer.scrollLeft = leftPosition;
			window.scrollTo(0, leftPosition);

			aboutContentTranslate(scrollAmount, times);
		}
	});

	const scrollAnchors = document.querySelectorAll(
		'[data-about-section-trigger]'
	);
	let activeAnchor = document.querySelector(
		'[data-about-section-trigger].is-active'
	);

	const updateAnchors = (scrollX) => {
		scrollAnchors.forEach((anchor) => {
			const target = document.querySelector(
				`[data-about-section-target=${anchor.dataset.aboutSectionTrigger}]`
			);

			if (target && target.offsetLeft <= scrollX) {
				activeAnchor = anchor;
			}
		});

		getSiblings(activeAnchor).forEach((item) => {
			item.classList.remove('is-active');
		});

		activeAnchor.classList.add('is-active');
	};

	if (scrollAnchors.length > 0) {
		document.addEventListener('scroll', () => {
			updateAnchors(scrollXSpy);
		});

		if (window.scrollY > 0) {
			updateAnchors(scrollXSpy);
		}
	}
};
// execute pieces and components functions
initMarquee();
initAccordions();
initItemQuantity();
initFields();
initEmailCapture();
initContentLayout();
initMatch();
initEmblaSlider();
initPDPGallery();
initVimeoPlayer();
initComboBox();
initCart();

// execute global and component functions
initPageTransition();
initPageAnimation();

// execute page specific functions
switch (root.id) {
	case 'template-frontpage':
		initFrontpage();
		break;

	case 'template-product-index':
		initProductIndex();
		break;

	case 'template-product-single':
		initProductSingle();
		break;

	case 'template-blog-index':
		initBlogIndex();
		break;

	case 'template-account':
		initAccount();
		break;

	case 'template-page-about':
		initAbout();
		break;

	case 'template-page-faq':
		initFaq();
		break;
}

// make visible .avoid-style-flash elements
setTimeout(() => {
	document.querySelectorAll('.avoid-style-flash').forEach((el) => {
		el.style.visibility = 'visible';
	});
}, 400);
